"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Skeleton } from "@/components/ui/skeleton";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function ProductsGridConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="flex flex-col items-center">
            <div className="w-full border border-border p-3 bg-card">
              <AspectRatio ratio={1}>
                <Skeleton className="w-full h-full" />
              </AspectRatio>
            </div>
            <Skeleton className="h-8 w-3/4 mt-6" />
            <Skeleton className="h-10 w-1/2 mt-4" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="text-center py-12 text-destructive">
        <p>Error al cargar los productos. Por favor, inténtelo de nuevo más tarde.</p>
      </div>;
  }
  if (products.length === 0) {
    return <div className="text-center py-12 text-muted-foreground">
        <p>No se encontraron productos en esta categoría.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
      {products.map((product, i) => <div key={product.id} data-index={i} className="flex flex-col items-center group">
          <Link to={product.link} className="w-full block">
            <div className="border border-border p-3 bg-card transition-shadow duration-300 group-hover:shadow-md">
              <AspectRatio ratio={1}>
                {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="w-full h-full object-cover" loading="lazy" /> : <div className="w-full h-full bg-muted flex items-center justify-center text-muted-foreground">
                    Sin imagen
                  </div>}
              </AspectRatio>
            </div>
            <h3 className="text-center mt-6 text-2xl font-default font-medium text-foreground group-hover:text-primary transition-colors">
              {product.title}
            </h3>
          </Link>
          <div className="mt-4 w-full flex justify-center">
            <AddToCartButton productId={product.id} className="w-full max-w-[200px]" buttonClassName="bg-primary text-primary-foreground w-full" text="Agregar al carrito" showQuantity={false} />
          </div>
        </div>)}
    </div>;
}
export default function ProductsGrid() {
  const wp_query_params = {
    per_page: 6,
    post_type: "product"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="products-grid" className="bg-background pb-24">
      {}
      <div className="relative h-[300px] md:h-[400px] w-full bg-muted overflow-hidden">
        <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/structural_steel_header.png)]" aria-hidden="true" />
        <div className="absolute inset-0 bg-black/40" />
        <div className="relative h-full container mx-auto px-4 flex items-center justify-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold text-white tracking-wide text-center uppercase">
            Estructurales
          </h1>
        </div>
      </div>

      {}
      <div className="container mx-auto px-4 pt-16 pb-8">
        <div className="max-w-5xl mx-auto">
          <p className="text-foreground/80 text-base md:text-lg leading-relaxed text-justify md:text-left">
            Se utilizan en la fabricación de estructuras metálicas para construcciones industriales, señalamientos, invernaderos, entre otras. Son elementos que forman la parte resistente de una construcción. El sistema estructural en acero se basa en un marco o esqueleto de cualquier estructura cuyos componentes en su mayoría son columnas y vigas de acero, estos elementos nos ayudan para soportar el suelo, techo y las paredes de un edificio. Los perfiles se nombran en forma abreviada usando su altura o peralte y su peso por unidad de longitud.
          </p>
        </div>
      </div>

      {}
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <EcommerceProductsProvider wp_query={{
          per_page: 6,
          post_type: "product"
        }}>
            <ProductsGridConsumer />
          </EcommerceProductsProvider>
        </div>
      </div>
    </section>;
}